// components/Layout.tsx
import { Box, Container } from '@mui/material';
import React from 'react';
import Footer from './Footer';
import LayoutStyle from './Layout.style';
import PrimarySearchAppBar from './TopNavbar';

interface ILayoutProps {
    children: React.ReactNode;
    colorModeToggle: () => void;
}

const Layout: React.FC<ILayoutProps> = ({ children, colorModeToggle }) => {
    return (
        <Box sx={LayoutStyle.container}>
            <PrimarySearchAppBar colorModeToggle={colorModeToggle} />

            <Container
                maxWidth="lg"
                component="main"
                sx={{
                    ...LayoutStyle.body,
                    flex: 1, // make body grow
                    display: 'flex',
                    flexDirection: 'column'
                }}
            >
                {children}
            </Container>

            {/* footer stays pinned at bottom */}
            <Footer />
        </Box>
    );
};

export default Layout;
